var positionMap = {
    static: "static",
    absolute: "absolute",
    fixed: "fixed",
    relative: "relative",
    sticky: "sticky",
    initial: "initial",
    inherit: "inherit",
};
export default (function (_a) {
    var position = _a.position;
    return position in positionMap ? "position: " + position + ";" : "";
});
